@if (!rows.length) {
    <p class="empty">None of these have a capacity set, so their load can't be shown. Set the people or their availability to give them one.</p>
} @else {
    <div class="chart-legend" aria-label="What the colours mean">
        @for (c of counts; track c.status) {
            <span class="legend-item"><span class="swatch" [style.background]="c.colour"></span>{{c.label}} <b>{{c.count}}</b></span>
        }
        @if (noCapacity) {
            <span class="legend-note">{{noCapacity}} without a capacity set {{noCapacity === 1 ? 'isn\'t' : 'aren\'t'}} shown</span>
        }
    </div>
    <div class="chart-box" [style.height.px]="height">
        <canvas baseChart [type]="'bar'" [datasets]="datasets" [labels]="labels" [options]="options" [plugins]="plugins" (chartClick)="onClick($event)"
            role="img" [attr.aria-label]="'Work against capacity for ' + rows.length + ' nodes'"></canvas>
    </div>
}
